// Conversion event IDs shared between the browser event and the backend request.
// Format is fixed by the backend's MetaConversionTrackingEvent: `tb_` + 32 lowercase hex.
const HEX = '0123456789abcdef';

const randomHex32 = () => {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID().replace(/-/g, '').toLowerCase();
  }
  const bytes = new Uint8Array(16);
  if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  let out = '';
  bytes.forEach((b) => {
    out += HEX[b >> 4] + HEX[b & 15];
  });
  return out;
};

export const generate = () => `tb_${randomHex32()}`;
